/* Ask Noel — Knowledge Constellation · main app (vanilla JS, canvas 2D) */
(function () {
  'use strict';
  var D = window.NW_DATA;
  var C = D.CONCEPTS;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- DOM ---------- */
  var cv = document.getElementById('stage');
  var ctx = cv.getContext('2d');
  var detailEl = document.getElementById('detail');
  var announcer = document.getElementById('announcer');
  var hintEl = document.getElementById('hint');
  var sky2d = document.getElementById('sky2d');
  var mobileMode = false;

  /* ---------- assets ---------- */
  /* spriteSrc: resolves a sprite name ("07" or "07-lg") to a URL. A standalone
     build can pre-define window.NW_SPRITES (name → data URI) and we use it. */
  function spriteSrc(name) {
    return (window.NW_SPRITES && window.NW_SPRITES[name]) || ('assets/planets/' + name + '.webp');
  }
  var sprites = [];
  C.forEach(function (c, i) {
    var img = new Image();
    img.decoding = 'async';
    img.src = spriteSrc(String(i + 1).padStart(2, '0'));
    sprites.push(img);
  });
  function glowSprite(color) {
    var s = 128, g = document.createElement('canvas');
    g.width = s; g.height = s;
    var gx = g.getContext('2d');
    var grad = gx.createRadialGradient(s / 2, s / 2, 0, s / 2, s / 2, s / 2);
    grad.addColorStop(0, color + '55');
    grad.addColorStop(0.55, color + '22');
    grad.addColorStop(1, color + '00');
    gx.fillStyle = grad;
    gx.fillRect(0, 0, s, s);
    return g;
  }
  var glows = {};
  Object.keys(D.THEME_COLORS).forEach(function (t) { glows[t] = glowSprite(D.THEME_COLORS[t]); });

  /* ---------- layout ---------- */
  var scheme = 'stage';
  function rnd(i, k) { var x = Math.sin((i + 1) * 12.9898 + (k + 1) * 78.233) * 43758.5453; return (x - Math.floor(x)) * 2 - 1; }
  C.forEach(function (c, i) { c.off = [rnd(i, 0), rnd(i, 1), rnd(i, 2)]; c.x = 0; c.y = 0; c.z = 0; });

  function sphere(n) {
    var p = [], off = 2 / n, inc = Math.PI * (3 - Math.sqrt(5));
    for (var i = 0; i < n; i++) {
      var y = i * off - 1 + off / 2, r = Math.sqrt(Math.max(0, 1 - y * y)), phi = i * inc;
      p.push([Math.cos(phi) * r, y, Math.sin(phi) * r]);
    }
    return p;
  }
  function ringRad(ri) { return 84 + ri * 62; }
  /* The life-stage "journey": a winding path forward through space.
     u is in planet-index units (0..53). */
  function pathPoint(u) {
    return {
      x: Math.sin(u * 0.42) * 112 + Math.sin(u * 0.11 + 1.7) * 150,
      y: Math.sin(u * 0.23 + 0.5) * 18,
      z: u * 86
    };
  }
  var STAGE_STARTS = [0, 8, 21, 32, 46];
  var clusterPosts = []; // group label anchors for theme / book views
  function applyTargets() {
    if (scheme === 'stage') {
      clusterPosts = [];
      C.forEach(function (c, i) {
        var p = pathPoint(i);
        c.tx = p.x + c.off[0] * 16;
        c.ty = p.y + c.off[1] * 12;
        c.tz = p.z;
      });
      return;
    }
    var key = scheme === 'theme' ? 't' : 'b';
    var groups = [];
    C.forEach(function (c) { if (groups.indexOf(c[key]) < 0) groups.push(c[key]); });
    var cen = sphere(groups.length), R = 225, spread = 68;
    clusterPosts = groups.map(function (g, gi) {
      return {
        name: g,
        x: cen[gi][0] * R,
        y: cen[gi][1] * R - (spread + 38),
        z: cen[gi][2] * R,
        color: scheme === 'theme' ? D.THEME_COLORS[g] : null
      };
    });
    C.forEach(function (c) {
      var gi = groups.indexOf(c[key]), g = cen[gi];
      c.tx = g[0] * R + c.off[0] * spread;
      c.ty = g[1] * R + c.off[1] * spread;
      c.tz = g[2] * R + c.off[2] * spread;
    });
  }
  applyTargets();
  C.forEach(function (c) { c.x = c.tx; c.y = c.ty; c.z = c.tz; });

  /* ---------- camera ---------- */
  var cam = { yaw: 0.4, pitch: -0.72, zoom: 1, cx: 0, cy: 0, cz: 0, ox: 0 };
  var camT = { yaw: 0.4, pitch: -0.72, zoom: 1, cx: 0, cy: 0, cz: 0, ox: 0 };
  var focusDim = 0; // eased 0..1: how much non-selected planets recede
  var pathPos = 0;          // where we are along the journey (planet-index units)
  var followPath = true;    // camera follows the path (stage scheme, nothing selected)
  var dragYaw = 0, dragPitch = 0; // user look-around offsets while following the path
  var autoRotate = !reduceMotion;
  var EASE = reduceMotion ? 1 : 0.085;

  /* ---------- canvas ---------- */
  var W = 0, H = 0, DPR = 1;
  var bgCanvas = null;
  var starsA = [], starsB = [];
  function resize() {
    W = window.innerWidth; H = window.innerHeight;
    DPR = Math.min(window.devicePixelRatio || 1, 2);
    cv.width = W * DPR; cv.height = H * DPR;
    ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    bgCanvas = document.createElement('canvas');
    bgCanvas.width = W; bgCanvas.height = H;
    var b = bgCanvas.getContext('2d');
    var g = b.createLinearGradient(0, 0, 0, H);
    g.addColorStop(0, '#0C1430'); g.addColorStop(0.52, '#081024'); g.addColorStop(1, '#070C1C');
    b.fillStyle = g; b.fillRect(0, 0, W, H);
    var hg = b.createRadialGradient(W / 2, H + H * 0.42, 0, W / 2, H + H * 0.42, H * 1.05);
    hg.addColorStop(0, 'rgba(226,156,80,0.18)');
    hg.addColorStop(0.45, 'rgba(226,156,80,0.05)');
    hg.addColorStop(1, 'rgba(226,156,80,0)');
    b.fillStyle = hg; b.fillRect(0, 0, W, H);
    starsA = []; starsB = [];
    var i;
    for (i = 0; i < 110; i++) starsA.push([Math.random() * W, Math.random() * H, Math.random() * 1.2 + 0.3, 0.2 + Math.random() * 0.45, Math.random() * Math.PI * 2]);
    for (i = 0; i < 60; i++) starsB.push([Math.random() * W, Math.random() * H, Math.random() * 1.7 + 0.6, 0.3 + Math.random() * 0.55, Math.random() * Math.PI * 2]);
  }
  window.addEventListener('resize', resize);
  resize();

  function proj(x, y, z) {
    x -= cam.cx; y -= cam.cy; z -= cam.cz;
    var cyw = Math.cos(cam.yaw), syw = Math.sin(cam.yaw);
    var cp = Math.cos(cam.pitch), sp = Math.sin(cam.pitch);
    var x1 = x * cyw - z * syw, z1 = x * syw + z * cyw;
    var y1 = y * cp - z1 * sp, z2 = y * sp + z1 * cp;
    var focal = 620;
    var sc = focal / (focal + z2) * cam.zoom;
    return { x: W / 2 - cam.ox + x1 * sc, y: H / 2 + y1 * sc, sc: sc, z: z2 };
  }

  /* ---------- state ---------- */
  var hover = -1, selected = -1, visited = {}, visitedCount = 0;
  var t0 = performance.now();

  /* ---------- render ---------- */
  function render(now) {
    var t = (now - t0) / 1000;
    ctx.clearRect(0, 0, W, H);
    ctx.drawImage(bgCanvas, 0, 0);

    // stars with parallax + twinkle
    var pa = cam.yaw * 30, pb = cam.yaw * 70;
    var i, s, sx;
    ctx.fillStyle = '#E9EDF8';
    for (i = 0; i < starsA.length; i++) {
      s = starsA[i];
      sx = ((s[0] + pa) % W + W) % W;
      ctx.globalAlpha = s[3] * (reduceMotion ? 1 : 0.75 + 0.25 * Math.sin(t * 0.7 + s[4]));
      ctx.fillRect(sx, s[1], s[2], s[2]);
    }
    for (i = 0; i < starsB.length; i++) {
      s = starsB[i];
      sx = ((s[0] + pb) % W + W) % W;
      ctx.globalAlpha = s[3] * (reduceMotion ? 1 : 0.7 + 0.3 * Math.sin(t * 0.9 + s[4]));
      ctx.fillRect(sx, s[1], s[2], s[2]);
    }
    ctx.globalAlpha = 1;

    // the journey path + stage signposts (stage scheme)
    if (scheme === 'stage') {
      var pf = 1 - focusDim * 0.72;
      // path line, fading with distance
      ctx.lineWidth = 1.2;
      var prevQ = null;
      for (var u = -0.8; u <= 53.8; u += 0.35) {
        var pp = pathPoint(u);
        var q = proj(pp.x, pp.y + 26, pp.z); // slightly below the planets, like a road
        if (prevQ && q.sc > 0.04 && prevQ.sc > 0.04) {
          var segA = Math.max(0, Math.min(0.42, ((q.sc + prevQ.sc) / 2) * 0.34)) * pf;
          if (segA > 0.01) {
            ctx.strokeStyle = 'rgba(216,182,131,' + segA.toFixed(3) + ')';
            ctx.beginPath(); ctx.moveTo(prevQ.x, prevQ.y); ctx.lineTo(q.x, q.y); ctx.stroke();
          }
        }
        prevQ = q;
      }
      // signposts drawn after planets (see below) so they stay readable
    }

    // project all
    C.forEach(function (c) { c.p = proj(c.x, c.y, c.z); });

    // edges
    ctx.globalCompositeOperation = 'lighter';
    ctx.lineWidth = 1;
    D.EDGES.forEach(function (e) {
      var a = C[e[0]].p, b = C[e[1]].p;
      var hot = (selected >= 0 && (e[0] === selected || e[1] === selected));
      var depthFade = Math.max(0, Math.min(1, (a.sc + b.sc) / 2));
      ctx.globalAlpha = hot ? 1 : depthFade;
      ctx.strokeStyle = hot ? 'rgba(235,217,180,0.5)' : 'rgba(180,190,220,' + (0.13 * (1 - focusDim * 0.75)).toFixed(3) + ')';
      ctx.beginPath(); ctx.moveTo(a.x, a.y); ctx.lineTo(b.x, b.y); ctx.stroke();
    });
    ctx.globalAlpha = 1;
    ctx.globalCompositeOperation = 'source-over';

    // planets, far to near (labels collected and drawn afterwards so no planet buries them)
    var labelQueue = [];
    var order = C.map(function (c, j) { return j; }).sort(function (a2, b2) { return C[b2].p.z - C[a2].p.z; });
    order.forEach(function (j) {
      var c = C[j], p = c.p;
      if (p.sc <= 0) return;
      var sel = (j === selected), hov = (j === hover);
      var bob = reduceMotion ? 0 : Math.sin(t * 0.6 + j) * (sel ? 0.7 : 2.2);
      var py = p.y + bob * p.sc;
      var base = 62 * (sel ? 1.5 : hov ? 1.15 : 1);
      var size = base * p.sc;
      var depthA = (scheme === 'stage')
        ? Math.max(0.08, Math.min(1, (p.sc - 0.22) * 1.5)) // distance fog along the road
        : Math.max(0.45, Math.min(1, (p.z + 300) / 420 * 0.5 + 0.62));
      if (!sel && !hov) depthA *= (1 - focusDim * 0.7);
      // glow
      var gs = size * 2.1;
      ctx.globalAlpha = depthA * (sel ? 0.95 : 0.55 * (1 - focusDim * 0.55));
      ctx.drawImage(glows[c.t], p.x - gs / 2, py - gs / 2, gs, gs);
      // sprite (selected planet upgrades to the large sprite once loaded)
      ctx.globalAlpha = depthA;
      var img = (sel && c.imgLg && c.imgLg.complete && c.imgLg.naturalWidth) ? c.imgLg : sprites[j];
      if (img.complete && img.naturalWidth) {
        ctx.drawImage(img, p.x - size / 2, py - size / 2, size, size);
      } else {
        ctx.fillStyle = D.THEME_COLORS[c.t];
        ctx.beginPath(); ctx.arc(p.x, py, size * 0.3, 0, Math.PI * 2); ctx.fill();
      }
      ctx.globalAlpha = 1;
      // selection ring
      if (sel) {
        ctx.strokeStyle = 'rgba(235,217,180,0.7)';
        ctx.lineWidth = 1.2;
        ctx.beginPath(); ctx.arc(p.x, py, size * 0.58, 0, Math.PI * 2); ctx.stroke();
      }
      // label
      var front, la;
      if (scheme === 'stage') {
        // only the nearest few planets get labels — the rest converge on the
        // vanishing point and would pile up
        front = p.z < 100;
        la = sel || hov ? 1
          : Math.max(0, Math.min(1, (100 - p.z) / 160))
            * Math.max(0, Math.min(1, (p.z + 700) / 300))
            * 0.92 * (1 - focusDim);
      } else {
        front = p.z < -60;
        la = sel || hov ? 1 : Math.max(0, Math.min(1, (-p.z - 60) / 120)) * 0.92 * (1 - focusDim);
      }
      if (sel || hov || (front && focusDim < 0.85)) {
        labelQueue.push({
          x: p.x, y: py + size * 0.5 + 16,
          text: c.l, sub: (sel || hov) ? c.t.toUpperCase() : null,
          col: D.THEME_COLORS[c.t],
          fs: sel ? 16 : 12, la: la, sel: sel
        });
      }
    });

    // label pass — always on top of planet sprites
    ctx.textAlign = 'center';
    ctx.shadowColor = 'rgba(4,7,16,0.95)';
    ctx.shadowBlur = 7;
    labelQueue.forEach(function (L) {
      ctx.globalAlpha = L.la;
      ctx.fillStyle = L.sel ? '#F4EFE4' : 'rgba(228,230,240,0.88)';
      ctx.font = (L.sel ? '600 ' : '500 ') + L.fs + 'px "Instrument Sans", sans-serif';
      ctx.fillText(L.text, L.x, L.y);
      if (L.sub) {
        ctx.fillStyle = L.col;
        ctx.font = '600 10.5px "Instrument Sans", sans-serif';
        ctx.fillText(L.sub, L.x, L.y + 15);
      }
    });
    ctx.shadowBlur = 0;
    ctx.textAlign = 'left';
    ctx.globalAlpha = 1;

    // stage signposts — drawn after planets so they never get buried
    if (scheme === 'stage') {
      var spf = 1 - focusDim * 0.85;
      ctx.textAlign = 'center';
      for (var si = 0; si < STAGE_STARTS.length; si++) {
        var c0 = C[STAGE_STARTS[si]];
        var lift = 92 + (si % 2) * 36; // stagger heights so neighbouring posts never collide
        var sp = proj(c0.x, c0.y - lift, c0.z);
        if (sp.sc <= 0.12) continue;
        // only the current and upcoming stage read; the rest wait in the fog
        var sa = Math.max(0, Math.min(0.85, (sp.sc - 0.42) * 1.7)) * spf;
        // fade out the stage you've already passed
        sa *= Math.max(0, Math.min(1, (sp.z + 520) / 220));
        if (sa <= 0.02) continue;
        var tickTop = proj(c0.x, c0.y - (lift - 18), c0.z);
        var tickBot = proj(c0.x, c0.y - 44, c0.z);
        ctx.strokeStyle = 'rgba(216,182,131,' + (sa * 0.6).toFixed(3) + ')';
        ctx.lineWidth = 1;
        ctx.beginPath(); ctx.moveTo(tickBot.x, tickBot.y); ctx.lineTo(tickTop.x, tickTop.y); ctx.stroke();
        ctx.shadowColor = 'rgba(4,7,16,0.9)';
        ctx.shadowBlur = 6;
        ctx.fillStyle = 'rgba(216,182,131,' + sa.toFixed(3) + ')';
        ctx.font = '600 ' + Math.max(10, Math.min(15, 11 * sp.sc)).toFixed(1) + 'px "Instrument Sans", sans-serif';
        ctx.fillText(D.STAGES[si].toUpperCase().split('').join('\u200a\u200a'), sp.x, sp.y);
        ctx.shadowBlur = 0;
      }
      ctx.textAlign = 'left';
    }

    // cluster signposts for theme / book views — drawn after planets
    if (scheme !== 'stage' && clusterPosts.length) {
      var cpf = 1 - focusDim * 0.85;
      ctx.textAlign = 'center';
      clusterPosts.forEach(function (cp) {
        var q = proj(cp.x, cp.y, cp.z);
        if (q.sc <= 0.3) return;
        // recede hard once the cluster rotates to the back hemisphere
        var depthMul = q.z <= 0 ? 1 : Math.max(0.1, 1 - q.z / 170);
        // fade out near the top chrome instead of clipping under it
        var topMul = Math.max(0, Math.min(1, (q.y - 64) / 58));
        var qa = Math.max(0, Math.min(0.9, (q.sc - 0.3) * 1.4)) * cpf * depthMul * topMul;
        if (qa <= 0.02) return;
        ctx.shadowColor = 'rgba(4,7,16,0.9)';
        ctx.shadowBlur = 6;
        var fs2 = Math.max(10, Math.min(14, 11.5 * q.sc));
        if (cp.color) {
          ctx.fillStyle = cp.color;
          ctx.globalAlpha = qa;
          ctx.beginPath(); ctx.arc(q.x, q.y - fs2 - 7, 3.2, 0, Math.PI * 2); ctx.fill();
          ctx.globalAlpha = 1;
        }
        ctx.fillStyle = 'rgba(216,182,131,' + qa.toFixed(3) + ')';
        ctx.font = '600 ' + fs2.toFixed(1) + 'px "Instrument Sans", sans-serif';
        ctx.fillText(cp.name.toUpperCase(), q.x, q.y);
        ctx.shadowBlur = 0;
      });
      ctx.textAlign = 'left';
    }
  }

  function loop(now) {
    C.forEach(function (c) {
      c.x += (c.tx - c.x) * (reduceMotion ? 1 : 0.1);
      c.y += (c.ty - c.y) * (reduceMotion ? 1 : 0.1);
      c.z += (c.tz - c.z) * (reduceMotion ? 1 : 0.1);
    });
    // path-follow camera (life-stage journey)
    if (scheme === 'stage' && followPath) {
      if (autoRotate && !dragging && selected < 0) pathPos = Math.min(53, pathPos + 0.0014);
      var ahead = 2.4;
      var basePt = pathPoint(pathPos + ahead);
      var tA = pathPoint(pathPos + ahead + 0.6), tB = pathPoint(pathPos + ahead - 0.6);
      camT.cx = basePt.x; camT.cy = basePt.y - 14; camT.cz = basePt.z;
      camT.yaw = Math.atan2(tA.x - tB.x, tA.z - tB.z) + dragYaw;
      camT.pitch = 0.17 + dragPitch; // far end of the road rises toward the horizon
      camT.ox = 0;
    } else if (autoRotate && !dragging && selected < 0 && scheme !== 'stage') {
      camT.yaw += 0.0014;
    }
    cam.yaw += (camT.yaw - cam.yaw) * EASE;
    cam.pitch += (camT.pitch - cam.pitch) * EASE;
    cam.zoom += (camT.zoom - cam.zoom) * EASE;
    cam.cx += (camT.cx - cam.cx) * EASE;
    cam.cy += (camT.cy - cam.cy) * EASE;
    cam.cz += (camT.cz - cam.cz) * EASE;
    cam.ox += (camT.ox - cam.ox) * EASE;
    focusDim += ((selected >= 0 ? 1 : 0) - focusDim) * (reduceMotion ? 1 : 0.07);
    if (!mobileMode) render(now);
    requestAnimationFrame(loop);
  }

  /* ---------- picking & pointer ---------- */
  var dragging = false, moved = false, lx = 0, ly = 0;
  var pinchD = 0;
  function pick(mx, my) {
    var best = -1, bd = 1e9;
    C.forEach(function (c, j) {
      if (!c.p) return;
      var r = Math.max(20, 34 * c.p.sc);
      var dx = c.p.x - mx, dy = c.p.y - my, d2 = Math.sqrt(dx * dx + dy * dy);
      if (d2 < r && c.p.z < bd) { bd = c.p.z; best = j; }
    });
    return best;
  }
  function hideHint() { if (hintEl && !hintEl.classList.contains('gone')) hintEl.classList.add('gone'); }

  cv.addEventListener('pointerdown', function (ev) {
    if (ev.pointerType === 'touch') return; // touch handled separately
    dragging = true; moved = false;
    lx = ev.clientX; ly = ev.clientY;
    cv.classList.add('dragging');
    cv.setPointerCapture(ev.pointerId);
    hideHint();
  });
  cv.addEventListener('pointermove', function (ev) {
    if (ev.pointerType === 'touch') return;
    if (dragging) {
      var dx = ev.clientX - lx, dy = ev.clientY - ly;
      if (Math.abs(dx) + Math.abs(dy) > 3) moved = true;
      if (scheme === 'stage' && followPath) {
        dragYaw += dx * 0.005;
        dragPitch += dy * 0.005;
        dragYaw = Math.max(-1.4, Math.min(1.4, dragYaw));
        dragPitch = Math.max(-0.55, Math.min(0.5, dragPitch));
      } else {
        camT.yaw += dx * 0.006; cam.yaw += dx * 0.006;
        camT.pitch += dy * 0.006; cam.pitch += dy * 0.006;
        camT.pitch = Math.max(-1.35, Math.min(0.4, camT.pitch));
        cam.pitch = Math.max(-1.35, Math.min(0.4, cam.pitch));
      }
      lx = ev.clientX; ly = ev.clientY;
    } else {
      hover = pick(ev.clientX, ev.clientY);
      cv.classList.toggle('hovering', hover >= 0);
    }
  });
  cv.addEventListener('pointerup', function (ev) {
    if (ev.pointerType === 'touch') return;
    dragging = false;
    cv.classList.remove('dragging');
    if (!moved) {
      var hit = pick(ev.clientX, ev.clientY);
      if (hit >= 0) selectPlanet(hit, true);
      else if (selected >= 0) closeDetail();
    }
  });
  cv.addEventListener('wheel', function (ev) {
    ev.preventDefault();
    hideHint();
    if (scheme === 'stage' && followPath) {
      // travel the path
      pathPos = Math.max(-0.5, Math.min(53, pathPos + ev.deltaY * 0.0045));
    } else {
      camT.zoom *= ev.deltaY < 0 ? 1.09 : 0.92;
      camT.zoom = Math.max(0.5, Math.min(5.5, camT.zoom));
    }
  }, { passive: false });

  // touch: one finger rotate, two finger pinch, tap select
  var touchStart = null;
  cv.addEventListener('touchstart', function (ev) {
    hideHint();
    if (ev.touches.length === 1) {
      touchStart = { x: ev.touches[0].clientX, y: ev.touches[0].clientY, t: Date.now() };
      lx = touchStart.x; ly = touchStart.y; moved = false;
    } else if (ev.touches.length === 2) {
      var dx = ev.touches[0].clientX - ev.touches[1].clientX;
      var dy = ev.touches[0].clientY - ev.touches[1].clientY;
      pinchD = Math.sqrt(dx * dx + dy * dy);
    }
  }, { passive: true });
  cv.addEventListener('touchmove', function (ev) {
    ev.preventDefault();
    if (ev.touches.length === 1 && touchStart) {
      var x = ev.touches[0].clientX, y = ev.touches[0].clientY;
      var dx = x - lx, dy = y - ly;
      if (Math.abs(x - touchStart.x) + Math.abs(y - touchStart.y) > 8) moved = true;
      if (scheme === 'stage' && followPath) {
        dragYaw += dx * 0.006;
        dragPitch += dy * 0.006;
        dragYaw = Math.max(-1.4, Math.min(1.4, dragYaw));
        dragPitch = Math.max(-0.55, Math.min(0.5, dragPitch));
        // vertical swipe also travels the path a little (natural on touch)
        pathPos = Math.max(-0.5, Math.min(53, pathPos - dy * 0.012));
      } else {
        camT.yaw += dx * 0.007; cam.yaw += dx * 0.007;
        camT.pitch += dy * 0.007; cam.pitch += dy * 0.007;
        camT.pitch = Math.max(-1.35, Math.min(0.4, camT.pitch));
        cam.pitch = camT.pitch;
      }
      lx = x; ly = y;
    } else if (ev.touches.length === 2) {
      var ddx = ev.touches[0].clientX - ev.touches[1].clientX;
      var ddy = ev.touches[0].clientY - ev.touches[1].clientY;
      var d = Math.sqrt(ddx * ddx + ddy * ddy);
      if (pinchD > 0) {
        camT.zoom *= d / pinchD;
        camT.zoom = Math.max(0.5, Math.min(5.5, camT.zoom));
      }
      pinchD = d;
    }
  }, { passive: false });
  cv.addEventListener('touchend', function (ev) {
    if (touchStart && !moved && ev.touches.length === 0 && Date.now() - touchStart.t < 400) {
      var hit = pick(touchStart.x, touchStart.y);
      if (hit >= 0) selectPlanet(hit, true);
      else if (selected >= 0) closeDetail();
    }
    touchStart = null; pinchD = 0;
  });

  /* ---------- keyboard ---------- */
  cv.addEventListener('keydown', function (ev) {
    var k = ev.key;
    if (k === 'ArrowRight' || k === 'ArrowLeft') {
      ev.preventDefault();
      hideHint();
      var n2 = selected < 0 ? (k === 'ArrowRight' ? 0 : C.length - 1) : (selected + (k === 'ArrowRight' ? 1 : -1) + C.length) % C.length;
      selectPlanet(n2, true);
    } else if (k === 'Enter' && hover >= 0) {
      selectPlanet(hover, true);
    } else if (k === 'Escape') {
      closeDetail();
    } else if (k === '+' || k === '=') {
      camT.zoom = Math.min(5.5, camT.zoom * 1.15);
    } else if (k === '-') {
      camT.zoom = Math.max(0.5, camT.zoom * 0.87);
    }
  });
  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape') {
      if (detailEl.classList.contains('open')) closeDetail();
    }
  });

  /* ---------- selection / detail ---------- */
  function flyTo(j) {
    var c = C[j];
    followPath = false;
    if (scheme === 'stage') pathPos = Math.max(0, Math.min(53, j)); // so Escape returns here
    camT.cx = c.tx; camT.cy = c.ty; camT.cz = c.tz;
    // zoom until the planet occupies a big share of the free viewport
    var panelW = (window.innerWidth > 720) ? 420 : 0;
    var avail = Math.min(W - panelW, H);
    camT.zoom = Math.max(2.9, Math.min(5.3, (avail * 0.6) / 93));
    camT.ox = panelW ? 195 : 0;
  }
  function resetCam() {
    if (scheme === 'stage') {
      followPath = true; // the per-frame follow block re-aims the camera
      camT.zoom = 1.5;
      camT.ox = 0;
      return;
    }
    camT.cx = 0; camT.cy = 0; camT.cz = 0;
    camT.zoom = 1;
    camT.ox = 0;
  }
  function num2(j) { return String(j + 1).padStart(2, '0'); }
  function esc(s2) { return s2.replace(/&/g, '&amp;').replace(/</g, '&lt;'); }

  function selectPlanet(j, fly) {
    selected = j;
    var c = C[j];
    if (!c.imgLg) {
      c.imgLg = new Image();
      c.imgLg.decoding = 'async';
      c.imgLg.src = spriteSrc(num2(j) + '-lg');
    }
    if (fly && !mobileMode) flyTo(j);
    if (mobileMode) scrollSkyTo(j);
    if (!visited[j]) { visited[j] = 1; visitedCount++; }
    renderDetail(j);
    detailEl.classList.add('open');
    detailEl.setAttribute('aria-hidden', 'false');
    if (location.hash !== '#p=' + (j + 1)) { try { history.replaceState(null, '', '#p=' + (j + 1)); } catch (e2) {} }
    announcer.textContent = c.l + '. ' + c.t + ', ' + D.STAGES[c.s] + '. From ' + c.b + '. Press Escape to close.';
    if (visitedCount === 3) maybeEmail();
  }

  function renderDetail(j) {
    var c = C[j];
    var col = D.THEME_COLORS[c.t];
    var related = [];
    D.EDGES.forEach(function (e) {
      if (e[0] === j) related.push(e[1]);
      else if (e[1] === j) related.push(e[0]);
    });
    var relHtml = '';
    if (related.length) {
      relHtml = '<div class="related"><div class="k">Related ideas</div><div class="chips">' +
        related.map(function (r) { return '<button type="button" data-fly="' + r + '">' + esc(C[r].l) + '</button>'; }).join('') +
        '</div></div>';
    }
    detailEl.innerHTML =
      '<button type="button" class="close" aria-label="Close panel">\u2715</button>' +
      '<div class="head">' +
      '<img src="' + spriteSrc(num2(j) + '-lg') + '" alt="" width="88" height="88" style="filter: drop-shadow(0 0 14px ' + col + '66);">' +
      '<div><div class="chip" style="color:' + col + '">' + esc(c.t) + ' <span class="stage">\u00b7 ' + esc(D.STAGES[c.s]) + '</span></div>' +
      '<h2 id="detail-title">' + esc(c.l) + '</h2></div></div>' +
      '<p class="body">' + esc(c.body) + '</p>' +
      '<div class="book">' +
      (D.BOOKS[c.b].cover
        ? '<img class="coverimg" src="' + D.BOOKS[c.b].cover + '" alt="Cover of ' + esc(c.b) + '" width="46" height="68" loading="lazy" style="width:46px;height:68px;object-fit:cover;border-radius:4px;flex:none;box-shadow:0 4px 14px rgba(2,4,12,0.5);">'
        : '<div class="cover">BOOK<br>COVER</div>') +
      '<div><div class="k">' + (c.ch
        ? 'From ' + (D.BOOKS[c.b].unit || 'chapter') + ' ' + esc(String(c.ch)) + ' of'
        : c.chName
          ? 'From \u2018' + esc(c.chName) + '\u2019 in'
          : 'From the book') + '</div><div class="t">' + esc(c.b) + '</div></div></div>' +
      '<a class="cta" href="reader.html?c=' + j + '">Click to read chapter \u2192</a>' +
      relHtml;
    detailEl.querySelector('.close').addEventListener('click', closeDetail);
    detailEl.querySelectorAll('[data-fly]').forEach(function (btn) {
      btn.addEventListener('click', function () { selectPlanet(parseInt(btn.getAttribute('data-fly'), 10), true); });
    });
  }

  function closeDetail() {
    selected = -1;
    detailEl.classList.remove('open');
    detailEl.setAttribute('aria-hidden', 'true');
    if (!mobileMode) resetCam();
    if (mobileMode) unselectSky();
    try { history.replaceState(null, '', location.pathname + location.search); } catch (e2) {}
    if (!mobileMode) cv.focus({ preventScroll: true });
  }

  /* ---------- schemes ---------- */
  var schemeBtns = document.querySelectorAll('.schemes button');
  function setScheme(s2) {
    scheme = s2;
    applyTargets();
    if (s2 === 'stage') {
      dragYaw = 0; dragPitch = 0;
      if (selected < 0) { followPath = true; camT.zoom = 1.5; camT.ox = 0; }
    } else {
      followPath = false;
      if (selected < 0) {
        camT.pitch = -0.3;
        camT.cx = 0; camT.cy = 0; camT.cz = 0;
        camT.zoom = 1; camT.ox = 0;
      }
    }
    if (selected >= 0) flyTo(selected); // re-centre on the selection in the new layout
    if (mobileMode) buildSky2d();
    if (hintEl && !hintEl.classList.contains('gone')) {
      hintEl.textContent = s2 === 'stage'
        ? 'scroll to travel the path \u00b7 drag to look around \u00b7 click a world'
        : 'drag to rotate \u00b7 scroll to zoom \u00b7 click a world';
    }
    schemeBtns.forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-scheme') === s2 ? 'true' : 'false');
    });
  }
  schemeBtns.forEach(function (b) {
    b.addEventListener('click', function () { setScheme(b.getAttribute('data-scheme')); });
  });

  /* ---------- search ---------- */
  var searchInput = document.getElementById('search-input');
  var resultsEl = document.getElementById('search-results');
  var activeResult = -1, currentResults = [];
  function score(c, q) {
    var L = c.l.toLowerCase(), K = c.kw, T = c.t.toLowerCase(), B = c.b.toLowerCase();
    if (L.indexOf(q) === 0) return 4;
    if (L.indexOf(q) >= 0) return 3;
    var words = q.split(/\s+/).filter(Boolean);
    var hit = 0;
    words.forEach(function (w) { if (K.indexOf(w) >= 0 || L.indexOf(w) >= 0) hit++; });
    if (hit === words.length && words.length) return 2.5;
    if (hit > 0) return 1 + hit / words.length;
    if (T.indexOf(q) >= 0 || B.indexOf(q) >= 0) return 0.8;
    return 0;
  }
  function runSearch() {
    var q = searchInput.value.trim().toLowerCase();
    activeResult = -1;
    if (q.length < 2) { resultsEl.hidden = true; resultsEl.innerHTML = ''; return; }
    var scored = C.map(function (c, j) { return { j: j, s: score(c, q) }; })
      .filter(function (r) { return r.s > 0; })
      .sort(function (a, b) { return b.s - a.s; })
      .slice(0, 7);
    currentResults = scored.map(function (r) { return r.j; });
    if (!scored.length) {
      resultsEl.innerHTML = '<div class="empty">No matching ideas \u2014 try \u201csuper\u201d, \u201cpension\u201d or \u201cwill\u201d.</div>';
      resultsEl.hidden = false;
      return;
    }
    resultsEl.innerHTML = scored.map(function (r, k) {
      var c = C[r.j];
      return '<button type="button" role="option" id="sr-' + k + '" data-j="' + r.j + '">' +
        '<img src="' + spriteSrc(num2(r.j)) + '" alt="" width="34" height="34">' +
        '<span>' + esc(c.l) + '<span class="meta">' + esc(c.t) + ' \u00b7 ' + esc(c.b) + '</span></span></button>';
    }).join('');
    resultsEl.hidden = false;
    resultsEl.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var j = parseInt(btn.getAttribute('data-j'), 10);
        resultsEl.hidden = true;
        searchInput.value = '';
        selectPlanet(j, true);
      });
    });
  }
  searchInput.addEventListener('input', runSearch);
  searchInput.addEventListener('keydown', function (ev) {
    var opts = resultsEl.querySelectorAll('button');
    if (ev.key === 'ArrowDown' || ev.key === 'ArrowUp') {
      if (!opts.length) return;
      ev.preventDefault();
      activeResult = ev.key === 'ArrowDown'
        ? (activeResult + 1) % opts.length
        : (activeResult - 1 + opts.length) % opts.length;
      opts.forEach(function (o, k) { o.setAttribute('aria-selected', k === activeResult ? 'true' : 'false'); });
      searchInput.setAttribute('aria-activedescendant', 'sr-' + activeResult);
    } else if (ev.key === 'Enter') {
      if (opts.length) {
        ev.preventDefault();
        opts[activeResult >= 0 ? activeResult : 0].click();
      }
    } else if (ev.key === 'Escape') {
      resultsEl.hidden = true;
      searchInput.blur();
    }
  });
  document.addEventListener('click', function (ev) {
    if (!ev.target.closest('.search')) resultsEl.hidden = true;
  });

  /* ---------- email card ---------- */
  var emailCard = document.getElementById('email-card');
  var emailShown = false;
  function maybeEmail() {
    if (mobileMode) return; // no email prompts on small screens
    var dismissed = false;
    try { dismissed = !!localStorage.getItem('nwEmailDismissed'); } catch (e2) {}
    if (emailShown || dismissed) return;
    emailShown = true;
    var tEl = emailCard.querySelector('.t'), bEl = emailCard.querySelector('.b');
    tEl.textContent = 'Take the universe with you';
    bEl.textContent = 'A free sample chapter and this map, straight to your inbox.';
    setTimeout(function () { emailCard.classList.add('open'); }, reduceMotion ? 0 : 600);
  }
  emailCard.querySelector('.close').addEventListener('click', function () {
    emailCard.classList.remove('open');
    try { localStorage.setItem('nwEmailDismissed', '1'); } catch (e2) {}
  });
  emailCard.querySelector('form').addEventListener('submit', function (ev) {
    ev.preventDefault();
    var v = emailCard.querySelector('input').value;
    if (!v) return;
    emailCard.querySelector('form').outerHTML = '<div class="ok">Thanks \u2014 it\u2019s on its way. (Demo \u2014 wiring to your email platform comes with the Shopify build.)</div>';
    try { localStorage.setItem('nwEmailDismissed', '1'); } catch (e2) {}
  });

  /* ---------- Scrolling Sky (small-screen 2D mode) ---------- */
  var skyBuiltScheme = null;
  var SKY_PATTERN = [
    { x: 8, s: 116 }, { x: 50, s: 96 }, { x: 18, s: 104 },
    { x: 46, s: 110 }, { x: 10, s: 92 }, { x: 42, s: 100 }
  ];
  function skyGroups() {
    if (scheme === 'stage') {
      return D.STAGES.map(function (sn, ri) {
        return { name: sn, members: C.map(function (c, j) { return j; }).filter(function (j) { return C[j].s === ri; }) };
      });
    }
    var key = scheme === 'theme' ? 't' : 'b';
    var names = [];
    C.forEach(function (c) { if (names.indexOf(c[key]) < 0) names.push(c[key]); });
    return names.map(function (n) {
      return { name: n, members: C.map(function (c, j) { return j; }).filter(function (j) { return C[j][key] === n; }) };
    });
  }
  function buildSky2d() {
    skyBuiltScheme = scheme;
    var inner = sky2d.querySelector('.inner');
    if (!inner) {
      var starsHost = document.createElement('div');
      starsHost.className = 'sky-stars';
      starsHost.setAttribute('aria-hidden', 'true');
      for (var si = 0; si < 90; si++) {
        var st = document.createElement('span');
        var sz = (0.5 + Math.random() * 1.6).toFixed(1);
        st.style.left = (Math.random() * 100) + '%';
        st.style.top = (Math.random() * 100) + '%';
        st.style.width = sz + 'px';
        st.style.height = sz + 'px';
        st.style.opacity = (0.15 + Math.random() * 0.45).toFixed(2);
        starsHost.appendChild(st);
      }
      sky2d.appendChild(starsHost);
      inner = document.createElement('div');
      inner.className = 'inner';
      var hh = document.createElement('div');
      hh.className = 'head-host';
      inner.appendChild(hh);
      var body2 = document.createElement('div');
      body2.className = 'sky-body';
      inner.appendChild(body2);
      sky2d.appendChild(inner);
    }
    var body = inner.querySelector('.sky-body');
    body.innerHTML = '';
    var pat = 0;
    skyGroups().forEach(function (g) {
      var gh = document.createElement('div');
      gh.className = 'ghead';
      gh.innerHTML = '<span class="gname"></span><span class="rule"></span><span class="gcount"></span>';
      gh.querySelector('.gname').textContent = g.name;
      gh.querySelector('.gcount').textContent = g.members.length + (g.members.length === 1 ? ' idea' : ' ideas');
      body.appendChild(gh);
      g.members.forEach(function (j) {
        var c = C[j];
        var p = SKY_PATTERN[pat % SKY_PATTERN.length]; pat++;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'planet';
        btn.setAttribute('data-p', j);
        btn.setAttribute('aria-label', c.l + '. ' + c.t + ', ' + D.STAGES[c.s] + '. Opens details.');
        btn.style.marginLeft = p.x + '%';
        var col = D.THEME_COLORS[c.t];
        btn.innerHTML =
          '<span class="ball" style="--pcolor:' + col + '">' +
          '<img src="' + spriteSrc(num2(j)) + '" alt="" width="' + p.s + '" height="' + p.s + '" loading="lazy" decoding="async"></span>' +
          '<span class="pl" style="display:block">' + esc(c.l) + '</span>' +
          '<span class="pt" style="display:block;color:' + col + '">' + esc(c.t) + '</span>';
        btn.addEventListener('click', function () { selectPlanet(j, false); });
        body.appendChild(btn);
      });
    });
    var end = document.createElement('p');
    end.className = 'endnote';
    end.textContent = 'That\u2019s all 54 \u2014 every idea links to the book that covers it properly.';
    body.appendChild(end);
  }
  function scrollSkyTo(j) {
    unselectSky();
    var btn = sky2d.querySelector('[data-p="' + j + '"]');
    if (!btn) return;
    btn.classList.add('sel');
    var top = btn.getBoundingClientRect().top + sky2d.scrollTop - 120;
    sky2d.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
  }
  function unselectSky() {
    var prev = sky2d.querySelector('.planet.sel');
    if (prev) prev.classList.remove('sel');
  }
  var headerNodes = [document.querySelector('.wordmark'), document.querySelector('.schemes'), document.querySelector('.search')];
  function enterMobile() {
    mobileMode = true;
    cv.style.display = 'none';
    if (hintEl) hintEl.classList.add('gone');
    sky2d.hidden = false;
    if (skyBuiltScheme !== scheme || !sky2d.querySelector('.inner')) buildSky2d();
    var hh = sky2d.querySelector('.head-host');
    headerNodes.forEach(function (n) { hh.appendChild(n); });
  }
  function exitMobile() {
    mobileMode = false;
    cv.style.display = 'block';
    sky2d.hidden = true;
    headerNodes.forEach(function (n) { document.body.appendChild(n); });
  }
  var mobileMQ = window.matchMedia('(max-width: 719px)');
  // Embed override: append ?view=3d or ?view=2d to the URL to force a mode
  // (useful when a host page's content column is narrower than 720px).
  var forceView = (location.search.match(/[?&]view=(3d|2d)/) || [])[1] || null;
  function applyMode() {
    var wantMobile = forceView === '2d' ? true : forceView === '3d' ? false : mobileMQ.matches;
    if (wantMobile && !mobileMode) enterMobile();
    else if (!wantMobile && mobileMode) exitMobile();
  }
  if (mobileMQ.addEventListener) mobileMQ.addEventListener('change', applyMode);
  else if (mobileMQ.addListener) mobileMQ.addListener(applyMode);

  /* ---------- deep link ---------- */
  (function initHash() {
    var m = location.hash.match(/^#p=(\d+)/);
    if (m) {
      var j = parseInt(m[1], 10) - 1;
      if (j >= 0 && j < C.length) setTimeout(function () { selectPlanet(j, true); }, reduceMotion ? 0 : 700);
    }
  })();

  setScheme('stage');
  applyMode();
  requestAnimationFrame(loop);
})();
